import { render } from "./TDIndex.vue?vue&type=template&id=c27474c0"
import script from "./TDIndex.vue?vue&type=script&lang=js"
export * from "./TDIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__